import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IntegradorService } from '../../../../../../services/integrador.service';
import { ToastService } from '../../../../../../services/toast.service';
import { ContratoTMA } from '../../../../../../types/ContratoTMA.type';
import { Empresa } from '../../../../../../types/Empresa.type';
import {ContratoService} from "../../../../../../services/contrato.service";

@Component({
  selector: 'app-tmaform',
  templateUrl: './tmaform.component.html',
  styleUrl: './tmaform.component.css'
})
export class TmaformComponent implements OnInit {

  taxa: ContratoTMA = {} as ContratoTMA
  taxaCadastro: ContratoTMA = {} as ContratoTMA;
  empresas: Empresa[] = [];

  constructor(private contratoService: ContratoService, private toastService: ToastService, private activatedRoute: ActivatedRoute, private location: Location, private integradorService: IntegradorService){}

  ngOnInit(){
    this.buscaProvisao()
    this.buscaEmpresas();
  }

  buscaProvisao(){
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if(id){
      this.contratoService.getTma(id).subscribe({
        next: (data) => {
          this.taxa = data
        },
        error: (error) => {
          console.error(error)
          this.toastService.erro("Erro", error.error.message)
        }
      })
    }
  }

  buscaEmpresas(){
    this.integradorService.getEmpresas().subscribe({
      next: (data) => {
        this.empresas = data
      },
      error: (error) => {
        console.error(error)
        this.toastService.erro("Erro", error.error.message)
      }
    })
  }

  salvar() {
    Object.assign(this.taxaCadastro, this.taxa);

    let empresaSelecionada = this.buscaEmpresaSelecionada(this.taxaCadastro.deEmpresa);

    if(empresaSelecionada != undefined){
      this.taxaCadastro.idEmpresa = empresaSelecionada.id;
    }

    this.taxaCadastro.deEmpresa = this.taxaCadastro.deEmpresa?.trim() != '' ? this.taxaCadastro.deEmpresa : '';
    this.taxaCadastro.dataInicial = this.taxaCadastro.dataInicial?.trim() != '' ? this.taxaCadastro.dataInicial : null;
    this.taxaCadastro.dataFinal = this.taxaCadastro.dataFinal?.trim() != '' ? this.taxaCadastro.dataFinal : null;

    if (this.taxa.id) {

      this.contratoService.putTma(this.taxaCadastro).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Provisão atualizada com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    } else {

      this.contratoService.postTma(this.taxaCadastro).subscribe({
        next: (valor) => {
          Object.assign(this.taxa, valor);
          this.toastService.sucesso('Sucesso', 'Provisão salva com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    }
  }

  buscaEmpresaSelecionada = (empresaErp: string): Empresa | undefined => {
    return this.empresas.find(empresa => empresa.empresaErp === empresaErp);
  };

  fecharDialog() {
    this.taxa = {} as ContratoTMA;
    this.location.back();
  }
}
